import Swiper from 'swiper'
import { debounce } from 'throttle-debounce'

class ProductsSlider {
  constructor(el) {
    this.container = el
    this.slider = null
    this.swiper = this.container.querySelector('.swiper')
    this.pagination = this.container.querySelector(
      '.products-slider__pagination'
    )
    this.next = this.container.querySelector('.products-slider__next')
    this.prev = this.container.querySelector('.products-slider__prev')
    this.slides = this.container.querySelectorAll('.swiper-slide')

    this.handleResponsive = this.handleResponsive.bind(this)

    this.settings = {
      loop: false,
      slidesPerView: 1,
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    }

    if (this.next && this.prev) {
      this.settings.navigation = {
        nextEl: this.next,
        prevEl: this.prev,
      }
    }

    if (this.pagination) {
      this.settings.pagination = {
        el: this.pagination,
        type: 'bullets',
        clickable: true,
      }
    }

    if (this.swiper) {
      this.handleResponsive()
      window.addEventListener('resize', debounce(250, this.handleResponsive))
    }
  }

  resetSwiper() {
    this.container.classList.add('products-slider--grid')
    this.container.classList.remove('products-slider--swiper')
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

  initSwiper() {
    this.container.classList.remove('products-slider--grid')
    this.container.classList.add('products-slider--swiper')
    if (!this.slider) {
      this.slider = new Swiper(this.swiper, this.settings)
    }
  }

  handleResponsive() {
    const { innerWidth } = window

    if (innerWidth >= 1200 && this.slides.length > 4) {
      this.initSwiper()
    } else if (innerWidth >= 1200 && this.slides.length <= 4) {
      this.resetSwiper()
    } else if (innerWidth >= 576 && this.slides.length > 2) {
      this.initSwiper()
    } else if (innerWidth >= 576 && this.slides.length <= 2) {
      this.resetSwiper()
    } else if (this.slides.length > 1) {
      this.initSwiper()
    } else {
      this.resetSwiper()
    }
  }
}

const productsSliderInit = {
  init() {
    const elements = document.querySelectorAll('.products-slider')
    Array.from(elements).map(element => new ProductsSlider(element))
  },
}

export default productsSliderInit
